/**
 * Service/Bs (BaaS) Controller
 *
 * Displays information about BaaS orders
 */

// the constructor for this object
function ServiceBsController() { }

// the object
ServiceBsController.prototype = {
    constructor: ServiceBsController,

    // the base order id
    baseOrderId: false,

    // store the chart data
    usageGraph: false,

    // store the local usage chart data
    localGraph: false,

    // initialize the controller
    init: function()
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();

        // register the route variables used by this controller
        this._registerRouteVariables();

        // register charts
        this._registerCharts();

        PortalHelper.debugMessage('Service BaaS Initialized');
    },

    // run the controller
    run: function()
    {

        // get and populate the orders
        this._getOrder();

        // get/populate the BaaS specific order info
        this._getBsOrder();

        // get order stats
        this._getOrderStats();

        // get managed backups
        this._getBsManagedBackups();

        // register the events used by this controller
        this._registerEvents();

        PortalHelper.debugMessage('Service BaaS Controller Ran');
    },

    // get the route variables and include them in the controller
    _registerRouteVariables: function()
    {
        var segments = PortalMain.getRouteSegments();

        // set the product cd
        if (segments.length == 1) {
            this.baseOrderId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },

    // register the javascript events
    _registerEvents:  function()
    {
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#range-selection-dropdown');
        $('#range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceBsController._updateChartRange(
                this.dataset.timelineRangeSeconds
            );

            PortalMain.ServiceBsController._updateSelectedRange(this);
        });

        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#backup-range-selection-dropdown');
        $('#backups-range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceBsController._updateBackupsRange(
                this.dataset.timelineRangeSeconds
            );

            PortalMain.ServiceBsController._updateBackupsSelectedRange(this);
        });
    },

    // register the chart
    _registerCharts: function()
    {
        // new chart for data usage history
        var UsageGraph = new PortalChart;
        UsageGraph.elementId = 'usage-chart';
        UsageGraph.type = 'line';
        UsageGraph.dataFormat = 'bytes';
        UsageGraph.columns = [];
        this.usageGraph = UsageGraph;

        // new chart for data usage history
        var LocalGraph = new PortalChart;
        LocalGraph.elementId = 'local-chart';
        LocalGraph.type = 'line';
        LocalGraph.dataFormat = 'bytes';
        LocalGraph.columns = [];
        this.localGraph = LocalGraph;
    },

    // get the orders from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;

        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;

        PortalMain.ServiceIndexController._getOrder();
    },

    // get BaaS specific order info (usage information)
    _getBsOrder: function()
    {
        var bsOrderRequest = new PortalRequest;
        bsOrderRequest.errorElement = '.order-fail';
        bsOrderRequest.makeRequest(
            '/orders-bs/get-order-bs',
            {
                baseOrderId: this.baseOrderId,
            },
            function(data) {
                PortalMain.ServiceBsController._populateBsOrderInfo(data);
                PortalMain.ServiceBsController._populateBsOrderRates(data);
            }
        )
    },

    // populate document with usage information
    _populateBsOrderInfo: function(bsInfo)
    {
        var productionBytes = PortalHelper.formatBytes(bsInfo.production_storage_size, 'GB', 'GB');
        var trialBytes = PortalHelper.formatBytes(bsInfo.trial_storage_size, 'GB', 'GB');
        var localBytes = PortalHelper.formatBytes(bsInfo.local_storage_size, 'GB', 'GB');

        // Populating fields in our template with stats from the API
        var rate = PortalHelper.numberToDollars(bsInfo.per_gb_rate, 2, true);
        $('#rate').text(rate);

        $('#production-size').text(PortalHelper.numberWithCommas(productionBytes[0]));
        $('#production-unit').text(productionBytes[1]);

        $('#trial-size').text(PortalHelper.numberWithCommas(trialBytes[0]));
        $('#trial-unit').text(trialBytes[1]);

        if (bsInfo.local_storage_size > 0) {
            $('#bs-meter-boxes').addClass('boxes-half');
            $('#local-storage-consumed').removeClass('hidden');
            $('#local-size').text(PortalHelper.numberWithCommas(localBytes[0]));
            $('#local-unit').text(localBytes[1]);
        }

        // totals for devices that are backed up
        $('#workstation-count').text(bsInfo.workstation_count);

        $('#vm-count').text(bsInfo.vm_count);

        $('#server-count').text(bsInfo.server_count);

        $('#mobile-count').text(bsInfo.mobile_count);

        var m365Count = bsInfo.mailbox_count + bsInfo.teams_count + bsInfo.sharepoint_sites_count
        $('#m365-count').text(m365Count);

        $('#website-count').text(bsInfo.website_count);

        PortalHelper.loadingOverlay('.stats', false);
    },

    // fill in and display the per GB rate
    _populateBsOrderRates: function(bsInfo)
    {
        // set the per gb rate
        var perGbRate = $('#usage-rates .clone-source').clone();
        perGbRate.removeClass('clone-source');

        $('.rate-label', perGbRate).text('Per Cloud GB Rate');

        var rate = bsInfo.per_gb_rate;
        rate = PortalHelper.numberToDollars(rate, 2, true);
        $('.rate-amount', perGbRate).text(rate);

        $('#usage-rates').append(perGbRate);

        // set the per vm rate
        if (bsInfo.per_local_gb_rate != undefined) {
            var perLocalGbRate = $('#usage-rates .clone-source').clone();
            perLocalGbRate.removeClass('clone-source');

            $('.rate-label', perLocalGbRate).text('Per Local GB Rate');

            var rate = bsInfo.per_local_gb_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', perLocalGbRate).text(rate);

            $('#usage-rates').append(perLocalGbRate);
        }

        // set the per vm rate
        if (bsInfo.bs_bm_rate != undefined) {
            var bsBmRate = $('#usage-rates .clone-source').clone();
            bsBmRate.removeClass('clone-source');

            $('.rate-label', bsBmRate).text('Management Rate');

            var rate = bsInfo.bs_bm_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', bsBmRate).text(rate);

            $('#usage-rates').append(bsBmRate);
        }

        if (bsInfo.bs_bo_rate != undefined) {
            var bsBoRate = $('#usage-rates .clone-source').clone();
            bsBoRate.removeClass('clone-source');

            $('.rate-label', bsBoRate).text('M365 Management Rate');

            var rate = bsInfo.bs_bo_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', bsBoRate).text(rate);

            $('#usage-rates').append(bsBoRate);
        }

        // show the usage rates
        $('#usage-rates').removeClass('hidden');
    },

    // retrieves historical usage information to fill our usage chart with
    _getOrderStats: function(startDate, endDate)
    {
        // defaulting to 1 month range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();

            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }

        var orderStatsRequest = new PortalRequest;
        orderStatsRequest.makeRequest(
            '/orders-bs/get-bs-storage-stats',
            {
                baseOrderId: this.baseOrderId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data) {

                PortalMain.ServiceBsController._populateUsageChart(data, startDate, endDate);
                PortalMain.ServiceBsController._populateLocalChart(data, startDate, endDate);
            }
        );
    },

    // sets up the usage graph, populating columns and data
    _populateUsageChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'Storage Consumed',
            'Trial Storage Consumed',
        ]);

        this.usageGraph.minDate = startDate;
        this.usageGraph.maxDate = endDate;
        // resetting columns first
        this.usageGraph.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.usageGraph.columns[i] = ['date', currentField];
            } else {
                this.usageGraph.columns[i] = ['number', currentField];
            }
        }

        if(chartData.length == 1) {
            $('#usage-chart').text("No data available for this period.");
        } else {
            this.usageGraph.data = chartData;
            this.usageGraph.draw();
        }
        PortalHelper.loadingOverlay('#usage-chart', false);
    },

    // sets up the local graph, populating columns and data
    _populateLocalChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'Local Storage Consumed',
        ]);

        // confirm that local storage is available, and toggle the chart accordingly
        var hasLocal = false;
        for(var i in chartData[0]) {
            if (chartData[0][i] == 'Local Storage Consumed') {
                hasLocal = true;
            }
        }
        if (!hasLocal) {
            $('#local-chart-container').addClass('hidden');
            return;
        }
        $('#local-chart-container').removeClass('hidden');

        this.localGraph.minDate = startDate;
        this.localGraph.maxDate = endDate;
        // resetting columns first
        this.localGraph.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.localGraph.columns[i] = ['date', currentField];
            } else {
                this.localGraph.columns[i] = ['number', currentField];
            }
        }

        if(chartData.length == 1) {
            $('#local-chart').text("No data available for this period.");
        } else {
            this.localGraph.data = chartData;
            this.localGraph.draw();
        }
        PortalHelper.loadingOverlay('#local-chart', false);
    },

    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#usage-chart', true);
        PortalHelper.loadingOverlay('#local-chart', true);

        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime()
            - (dateRangeSeconds * 1000)
        );

        this._getOrderStats(startDate, endDate);
    },

    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('#chart-box .selection-text').text(selectedElementText);
    },

    // get managed backups
    _getBsManagedBackups: function(startDate, endDate)
    {
        // defaulting to 1 month range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();

            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }

        var bsOrderRequest = new PortalRequest;
        bsOrderRequest.errorElement = '.order-fail';
        bsOrderRequest.makeRequest(
            '/orders-bs/get-bs-managed-backups',
            {
                baseOrderId: this.baseOrderId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data, code) {
                if (code != 'ORDER_BS_NOT_MANAGED') {
                    PortalMain.ServiceBsController._populateBackups(data);
                }
            }
        )
    },

    // fill and display the backup data for this managed order
    _populateBackups: function(backups)
    {
        $('#backups-table tbody tr:not(.clone-source)').remove();

        for (var i in backups) {
            var backup = backups[i];

            var newEntry = $('#backups-table .clone-source').clone();
            newEntry.removeClass('clone-source');

            // apply the machine name
            $('.machine', newEntry).html(backup.title);

            // apply the machine link
            var backupLink = PortalConfig.portalUrl;
            backupLink += '/service/bs-backup';
            backupLink += '/' + this.baseOrderId;
            backupLink += '/' + backup.acronis_resource_id_hash;
            $('.machine', newEntry).attr('href', backupLink);

            // apply the last backup
            var lastBackup = PortalHelper.formatDate(backup.last_backup);
            lastBackup += ' ' + PortalHelper.formatTime(backup.last_backup);
            $('.last-backup', newEntry).html(lastBackup);

            // apply the success count
            $('.success-count', newEntry).html(backup.ok_count);

            // apply the error count
            $('.error-count', newEntry).html(backup.error_count);

            // add to to the table
            $('#backups-table').append(newEntry);
        }

        $('#backups').removeClass('hidden');
        PortalHelper.loadingOverlay('#backups-table', false);

    },

    // changes what date range is displayed
    _updateBackupsRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#backups-table', true);
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime()
            - (dateRangeSeconds * 1000)
        );

        this._getBsManagedBackups(startDate, endDate);
    },

    // adds interactivity to the dropdown range selection
    _updateBackupsSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('#backups .selection-text').text(selectedElementText);
    },



}
